import { render } from "./ProjectResultDetailsList.vue?vue&type=template&id=68ca12ab"
import script from "./ProjectResultDetailsList.vue?vue&type=script&lang=js"
export * from "./ProjectResultDetailsList.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__